import React from "react";
import {
    Navigate,
    Outlet,
} from 'react-router-dom';
import {useCookies} from "react-cookie";
import {useGetUserAuthStatusQuery} from "../../features/user/userSlice";
import {CircularProgress} from "@mui/material";
import Stack from "@mui/material/Stack";

const PrivateRoute = ({children}) => {
    const [returnURL, setReturnURL, removeReturnURL] = useCookies(['returnURL']);
    const {data, isLoading, error} = useGetUserAuthStatusQuery()

    if (!isLoading) {
      if (data?.data?.is_authenticated) {
        removeReturnURL("returnURL", { path: "/" });
        return children ? children : <Outlet />;
      } else {
        setReturnURL("returnURL", "https://leasing.kalamarket.com", {
          path: "/",
          domain: "kalamarket.com",
        });
        window.location.href = "https://kalamarket.com?returnURL=leasing.kalamarket.com";
      }
    } else {
      return (
        <Stack alignItems={"center"} mt={4}>
          <CircularProgress thickness={5} />
        </Stack>
      );
    }
};

export default PrivateRoute;